import React, { FC, ReactNode } from 'react';

type RenderIfProps = {
  condition: boolean;
  children: ReactNode;
  fallback?: ReactNode;
  forceRender?: boolean;
  hiddenStyle?: React.CSSProperties;
  hiddenClassName?: string;
};

export const RenderIf: FC<RenderIfProps> = ({ condition, children, fallback = null, forceRender = false, hiddenStyle = { display: 'none' }, hiddenClassName = '' }) => {
  if (forceRender) {
    return (
      <div style={condition ? undefined : hiddenStyle} className={condition ? '' : hiddenClassName}>
        {children}
      </div>
    );
  }

  return condition ? <>{children}</> : <>{fallback}</>;
};
